import { render } from "./sso.vue?vue&type=template&id=300f96f3&ts=true"
import script from "./sso.ts?vue&type=script&lang=ts"
export * from "./sso.ts?vue&type=script&lang=ts"

import exportComponent from "/usr/src/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__